<template>
    <div class="need">
        <h2>定制需求</h2>
        <form action="https://guanwang.wsandos.com/home/index/getNeed" method="post" target="submitFrame">
            <div>
                <div ref="need">一句话描述您的需求，例如：房地产销售</div>
                <input type="text" placeholder="一句话描述您的需求，例如：房地产销售" @blur="hiddenneed" @focus="showneed" @input="valLength" ref="needinput" name="demand">
                <div class="count">{{count}}/20</div>
            </div>
            <div>
                <div ref="phone">请输入您的手机号码</div>
                <input type="text" placeholder="请输入您的手机号码" @blur="hiddenphone" @focus="showphone" @change="checkPhone" ref="phoneinput" name="phone">
            </div>
            <button @click="send">发送</button>
        </form>
        <iframe  id="submitFrame" style="display: none;width:0; height:0" name="submitFrame"  src="about:blank"></iframe>
    </div>
</template>

<script>
export default {
    name: "Need",
    data () {
        return {
            count: 0,
            phone: false
        }
    },
    methods: {
        valLength () {
            const needStr = this.$refs.needinput.value
            this.$refs.needinput.value = needStr.replace(/\s{2,}/g,' ')
            this.count = needStr.replace(/\s{1,}/g,'').length
            if( this.count > 20 ){
                this.count = 20
                this.$refs.needinput.value = needStr.substr( 0 , needStr.length - 1 )
            }
        },
        checkPhone () { 
            var phone = this.$refs.phoneinput.value;
            if(!(/^1[3456789]\d{9}$/.test(phone))){ 
                this.phone = false;
            }else{
                this.phone = true;
            }
        },
        send () {
            if(this.$refs.needinput.value.replace(/\s{1,}/g,'') ==''){
                alert("请填写内容！")
                event.preventDefault()
                return false
            }
            if(this.$refs.needinput.value.replace(/\s{1,}/g,'').length > 20){
                alert("超出20个字数限制！")
                event.preventDefault()
                this.$refs.needinput.value = ""
                this.count = 0
                return false
            }
            if(!this.phone){
                alert("手机号码有误，请重填");
                event.preventDefault()
                this.$refs.phoneinput.value = ""
                return false
            }
            alert("提交成功")
            this.count = 0
            setTimeout(()=>{
                this.$refs.needinput.value = ""
                this.$refs.phoneinput.value = ""
            },20)
        },
        showneed () {
            this.$refs.needinput.placeholder = ""
            this.$refs.need.style.color = "#999"
        },
        showphone () {
            this.$refs.phoneinput.placeholder = ""
            this.$refs.phone.style.color = "#999"
        },
        hiddenneed () {
            var input = this.$refs.needinput
            if(!input.value){
                input.placeholder = "一句话描述您的需求，例如：房地产销售"
                this.$refs.need.style.color = "#fff"
            }
        },
        hiddenphone () {
            var input = this.$refs.phoneinput
            if(!input.value){
                input.placeholder = "请输入您的手机号码"
                this.$refs.phone.style.color = "#fff"
            }
        }
    }
}
</script>

<style lang="stylus" scoped>
    @import '~styles/varible.styl'
     .need
        width: 100%
        max-width: 1920px
        min-width: 1440px
        margin: 0 auto
        position: relative
        padding: 100px 0  120px
        h2
            color: #000
            font-size: 34px
            line-height: 44px
            font-weight: 600
            margin-bottom: 100px
            text-align: center
        form
            margin: 0 auto
            width: 70%
            font-size: 18px
            >div
                position: relative
                display: inline-block
                width: 47%
                color: #999
                >div:first-of-type
                    color: #fff
                input
                    width: 100%
                    margin-top: 10px
                    line-height: 60px
                    color: #333
                    border: none
                    outline: none
                    border-bottom: 2px solid #999
                input:focus
                    border-bottom: 3px solid #666
                .count
                    position: absolute
                    right: 0
                    top: 58%
            >div:first-of-type
                margin-right: 4%
            button
                margin-top: 8%
                padding: 20px 100px
                background: #999
                color: #fff
                font-weight: 600
                font-size: 16px
                line-height: 16px
                outline: none
                border: none
</style>


// WEBPACK FOOTER //
// src/components/pc/ContactNeed.vue